import amplitude from 'utils/amplitude';
import { IOrder } from 'Modules/Cart/types';
import { EnumEvents, EnumGtagEvents } from 'constants/enums';
import { convertDashToSpace } from './utils';
import analyticsManager from '../tagManager/manager';

function formatForAmplitude(order: IOrder) {
  const { id: order_id } = order;

  return convertDashToSpace({
    order_id,
  });
}

export default function missproductsViewAnalitic(order: IOrder) {
  analyticsManager.gtag(EnumGtagEvents.VIEW_MISSING_PRODUCTS);
  amplitude.logEvent(EnumEvents.SHOPPING_VIEW_MISSPRODUCTS, formatForAmplitude(order));
}
